<div class="d-flex align-items-center justify-content-between px-4 pt-4 px-md-8 pt-md-8">
  <h1 class="semi-bold">Enter code</h1>

  <ds-button
    (click)="hideModal.emit()"
    variant="icon"
    size="s"
    icon="xmark"
    label="Close"
    class="d-none d-md-inline"
    data-id="hide"
  />
</div>

<p class="mt-2 mx-4 mx-md-8">
  We’ve sent an activation code to your email <b data-id="email">{{ verification.emailMasked }}</b
  >. Check junk mail if it’s not in your inbox.
</p>

<p *ngIf="domain" class="mt-4 mx-4 mx-md-8">
  <a
    (click)="$event.stopPropagation()"
    [href]="domain.url"
    target="_blank"
    class="link text-lightblue-600 d-flex"
    >Open {{ domain.label
    }}<img src="assets/icons/external_link.svg" alt="external_link" class="ml-1"
  /></a>
</p>

<form [formGroup]="form" class="mt-6 mx-4 mx-md-8 mb-8">
  <ds-otp-input
    formControlName="code"
    [length]="4"
    [autoFocus]="true"
    [error]="verificationError || undefined"
    [state]="otpState"
    inputId="verification-code"
    (completed)="onCompleted($event)"
  />

  <p *ngIf="verificationError" class="d-none" data-id="error">
    {{ verificationError }}
  </p>

  <ng-container *ngIf="timer$ | async as timer">
    <p *ngIf="timer > 0; else resendTemplate" class="mt-6 text-jazlyn-700">
      Resend code in {{ timer | formatMs }}
    </p>
  </ng-container>

  <ng-template #resendTemplate>
    <a
      (click)="$event.preventDefault(); sendVerificationEmail()"
      class="link text-lightblue-600 d-flex mt-6"
      data-id="resend"
      ><p>Send code</p></a
    >
  </ng-template>
</form>
